import { COMPONENTS_TYPES } from '@namespace/cms';
import { CookieManagementHr } from '@namespace/cookie-management';
import Deposit from '../Deposit';
import Footer from '../Footer';
import FooterContactInfoWithCustomChat from '../FooterContactInfoWithCustomChat';
import FooterMenu from '../FooterMenu';
import HeaderContactInfoWithCustomChat from '../Header/components/HeaderContactInfoWithCustomChat';
import LoginStepper from '../LoginStepper';
import PasswordRecovery from '../PasswordRecovery';
import ChangePassword from '../PersonalOffice/ChangePassword';
import ProfileData from '../PersonalOffice/ProfileData';
import ProfileDocuments from '../PersonalOffice/ProfileDocuments';
import VerificationFailureUpload from '../PersonalOffice/ProfileDocuments/VerificationFailure';
import VerificationSuccessUpload from '../PersonalOffice/ProfileDocuments/VerificationSuccess';
import Register from '../Register';
import SupportChatPage from '../SupportChatPage';
import Withdraw from '../Withdraw';

export const pageComponentsMap = {
  [COMPONENTS_TYPES.REGISTER]: Register,
  [COMPONENTS_TYPES.LOGIN_STEPPER]: LoginStepper,
  [COMPONENTS_TYPES.PROFILE_DATA]: ProfileData,
  [COMPONENTS_TYPES.DEPOSIT]: Deposit,
  [COMPONENTS_TYPES.PROFILE_DOCUMENTS]: ProfileDocuments,
  [COMPONENTS_TYPES.PASSWORD_RECOVERY]: PasswordRecovery,
  [COMPONENTS_TYPES.PROFILE_DOCUMENTS_VERIFICATION_SUCCESS]:
    VerificationSuccessUpload,
  [COMPONENTS_TYPES.PROFILE_DOCUMENTS_VERIFICATION_FAILURE]:
    VerificationFailureUpload,
  [COMPONENTS_TYPES.WITHDRAW]: Withdraw,
  [COMPONENTS_TYPES.CHANGE_PASSWORD]: ChangePassword,
  [COMPONENTS_TYPES.FOOTER_MENU]: FooterMenu,
  [COMPONENTS_TYPES.FOOTER_CONTACT_INFO_WITH_CUSTOM_CHAT]:
    FooterContactInfoWithCustomChat,
  [COMPONENTS_TYPES.HEADER_CONTACT_INFO_WITH_CUSTOM_CHAT]:
    HeaderContactInfoWithCustomChat,
  [COMPONENTS_TYPES.FOOTER]: Footer,
  [COMPONENTS_TYPES.COOKIE_MANAGEMENT]: CookieManagementHr,
  [COMPONENTS_TYPES.SUPPORT_CHAT_PAGE]: SupportChatPage
};
